import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const FirebaseConfig = {
  apiKey: "AIzaSyAymXU0E6fodxwiuuqgML9oJpB4KZgFPGo",
  authDomain: "rapidoo-rider-17523.firebaseapp.com",
  projectId: "rapidoo-rider-17523",
  storageBucket: "rapidoo-rider-17523.firebasestorage.app",
  messagingSenderId: "258729494628",
  appId: "1:258729494628:web:6e782e53d22bda9b3fb771",
  measurementId: "G-2HRG1RPCHG"
};

const tokenConfig = {
  vapidKey:
    'BL-nEXnArDRZ52qcF60rugOiWI33JT5c4d4G3q1R_wssCPyxc2INUvZqrNN-HFz8XH2jsXKKO_wOO6L_Ilew_iA'
};

let app, messaging;

class FcmNotification {
  static init() {
    if (!app) {
      app = initializeApp(FirebaseConfig);
      messaging = getMessaging(app);
    }
  }
  static setNotificationHandler(notificationHandler) {
    onMessage(messaging, notificationHandler);
  }

  static async getDeviceToken() {
    const token = await getToken(messaging, tokenConfig).catch((error) => {
      console.error('[FcmNotification] Failed to get token:', error);
      return null;
    });
    return token || '';
  }
}

export { FcmNotification };
